/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../../objects/context.js';
import $ from 'jquery';
import ko from 'knockout';
import axios from 'axios';
import numeral from 'numeral';

class templateWidgetModel {

    constructor(params) {
        // Profile
        console.log("percentage-widget:constructor: params: %o", params);

        numeral.defaultFormat('0,0');

        this.componentName = "percentage-widget";
        this.debug = true;
        this.context = context;
        this.id = params.id;
        this.index = ko.observable(params.index);
        this.visible = ko.observable(true);
        this.editable = ko.observable(params.editable);
        this.editableItems = ko.observable(params.editableItems);

        this.type = ko.observable(params.title);
        this.title = ko.observable(params.title);
        this.occ = params.occ;
        this.apiFunction = params.apiFunction;
        this.expanded = ko.observable(false);
        this.include = ko.observable(true);
        this.css = ko.observable("");

        this.totalPercent = ko.observableArray(0);

        this.listArray = ko.observableArray([]);

        this.fullUrl = "";

        this.content = ko.observable("");

        console.log("percentage-widget:constructor: this: %o", this);

        this.getData();


    }

    getData() {

        console.log("percentage-widget:getData: apiFunction: %o", this.apiFunction);

        let filter = encodeURI(JSON.stringify({"where": {"type": this.apiFunction }, "order":"sort"}));
        let url = context.generateApiUrl('/Componentlistdata?filter=' + filter );
        let callData = JSON.stringify({});

        $.ajax({
            url: url,
            method: "GET",
            headers: this.context.apiContentType,
            data: callData
        })
          .done((data, textResponse, request) => {
            //this.listArray(data);
            console.log("percentage-widget:getData:done: data: %o", data);
            this.handleGetData(data);
          })
          .fail((error, other1) => {
            console.log("physical-wdget:getData:fail: error: %o", error);
            this.context.eventManager.notifySubscribers({modalTitle:"API Error",modalBody:"Error calling isAuthenticated"},"messageModel");
          });
    }

    handleGetData(data) {

        let tempArray = [];

       ko.utils.arrayMap(data, function(item) {
            item.percentage = ko.observable(null);
            tempArray.push(item);
       });

        this.listArray(tempArray);
        console.log("percentage-widget:handleGetData: listArray: %o", this.listArray());
    }

    updateTitle() {
        console.log("percentage-widget:updateTitle:");
        this.updateContent(this);
    }

    clickExpanded() {
        console.log("clickExpanded");
        this.expanded(!this.expanded());
        console.log(this.expanded());
    }

    clickMoveUp(item, parents) {
        console.log("clickMoveUp");
        //console.log(item);
        //console.log(parents);
    }

    clickMoveDown(item, parents) {
        console.log("clickMoveDown");
        //console.log(item);
        //console.log(parents);
    }

    updateContent(parent) {

        console.log("percentage-widget:updateContent: parent: %o", parent);
        console.log("percentage-widget:updateContent: content: %o", parent.content());
        parent.content("");
        parent.totalPercent(0);

        ko.utils.arrayMap(parent.listArray().sort(parent.arraySorter), function(item) {

            //Check if integer and 100 or less
            if(!isNaN(parseFloat(item.percentage())) && isFinite(item.percentage())) {
                
                if(parseInt(parent.totalPercent() >= 101))
                {
                    item.percentage(100);
                }

            }
            else
            {
                item.percentage(null);
            }


            console.log("percentage-widget:updateContent: arrayMap:  Item: %o", item);

            if(item.percentage() > 0)
            {
                console.log("percentage-widget:updateContent: add Item: %o", item);
                parent.content( parent.content() + "<li class='jdm'>" + item.percentage() + "% - " + item.description + "</li>");

                parent.totalPercent( parseInt(parent.totalPercent()) + parseInt(item.percentage()) );
            }

       });

       console.log("percentage-widget:updateContent: after map: content: %o  length: %i", parent.content(), parent.content().length );

       if(parent.content().length > 0)
       {
           let newContent = "";
           newContent = "<h3 class='jdm'>" + parent.title() + "</h3><ul class='jdm'>" + parent.content() + "</ul>";
           console.log("percentage-widget:updateContent: newContent %s", newContent);
           parent.content(newContent); 
       }
       else
       {
        console.log("percentage-widget:updateContent: blank content: %o", parent.content());
       }

    }

    arraySorter(itemRight, itemLeft) {

        console.log("percentage-widget:arraySorter:");
        let sortOrder = 1;
        let result = 0;
        
        console.log("percentage-widget:arraySorter: itemRight: %o  itemLeft: %o", itemRight, itemLeft);
        //context.userJobsArray.

        result = (parseInt(itemRight.percentage()) > parseInt(itemLeft.percentage())) ? -1 : (parseInt(itemRight.percentage()) > parseInt(itemLeft.percentage())) ? 0 : 1;
        //result = (itemRight[column]() > itemLeft[column]()) ? -1 : (itemRight[column]() < itemLeft[column]()) ? 1 : 0;
        
        //console.log("nav-job-list:columnSorter: itemRight[column]: %o  itemLeft[column]: %o", itemRight[column](), itemLeft[column]());
        console.log("percentage-widget:arraySorter: result: %o  sortOrder: %o", result, sortOrder);

        return result * sortOrder;
        
    }

}

export default { viewModel: templateWidgetModel, template: require('!raw-loader!./percentage-widget.html') };


// WEBPACK FOOTER //
// ./src/components/job-create/sub/percentage-widget.js